import { lazy } from 'react';
import { LazyPanelBoundary, Sidebar } from '@/features/sidebar';
import { addonPurchaseRequest, ADDON_PURCHASE_SIDEBAR_ID } from './addon-purchase-request';

const LazyAddonPurchasePanel = lazy(() =>
  import('./addon-purchase-panel').then((module) => ({ default: module.AddonPurchasePanel })),
);

export function AddonPurchaseSidebar() {
  const request = addonPurchaseRequest.useRequestState();

  return (
    <Sidebar id={ADDON_PURCHASE_SIDEBAR_ID} onToggle={addonPurchaseRequest.handleToggle}>
      <LazyPanelBoundary resetKey={request?.key} onLoadError={() => addonPurchaseRequest.dismiss()}>
        {request == null ? null : (
          <LazyAddonPurchasePanel
            key={request.key}
            data={request.data}
            onConfirm={addonPurchaseRequest.confirm}
            onClose={() => addonPurchaseRequest.dismiss()}
            onBusyChange={addonPurchaseRequest.setBusy}
          />
        )}
      </LazyPanelBoundary>
    </Sidebar>
  );
}
